
import { Container, Img, Content, Title, PostDate } from "./postSecondStyle";
import { storageServerPath } from "../../utils/server/api";

export interface PostData {
  id: number;
  title: string;
  created_at: string;
  image: string;
  link: string;
}

interface PostSecondProps {
  data: PostData;
  classNames: string;
}

function formatDate(dateString: string) {
    const months = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro",
    ];

    const date = new Date(dateString);

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} de ${year}`;
}

const PostSecond = ({ data, classNames }: PostSecondProps ) => {
  return (
      <div className={`${classNames}`}>
          <a href={data.link} target="_blank" rel="noreferrer">
              <Img
                  src={`${storageServerPath}base64-files/pronouncements/${data.image}`}
                  alt={data.title}
              />
          </a>
          <div className="flex flex-col flex-1 pl-5">
              <a href={data.link} target="_blank" rel="noreferrer">
                  <h1 className="!text-2xl">{data.title}</h1>
              </a>
              <PostDate>{formatDate(data.created_at)}</PostDate>
          </div>
      </div>
  );
};

export default PostSecond;